import { getData, postData, putData, patchData, deleteData } from '../utils/api';

// Get all admins with pagination and filters
export const getAdmins = async (params = {}) => {
  const {
    page = 1,
    limit = 10,
    sortField = 'createdAt',
    sortValue = 'DESC',
    status = '',
    search = ''
  } = params;

  const queryParams = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString(),
    sortField,
    sortValue,
    ...(status && { status }),
    ...(search && { search })
  });

  return getData(`/entity/admin?${queryParams.toString()}`);
};

// Create a new admin
export const createAdmin = async (adminData) => {
  const { name, username, password, isPrimary } = adminData;
  
  const requestData = {
    name,
    username,
    password,
    isPrimary
  };
  
  console.log('AdminService - Creating admin with data:', requestData);
  return postData('/entity/admin', requestData);
};

// Update an existing admin
export const updateAdmin = async (adminData) => {
  const { adminId, name, username, status, password, isPrimary } = adminData;
  
  const updateData = { adminId };
  
  if (name !== undefined) updateData.name = name;
  if (username !== undefined) updateData.username = username;
  if (status !== undefined) updateData.status = status;
  if (isPrimary !== undefined) updateData.isPrimary = isPrimary;
  if (password) updateData.password = password;

  console.log('AdminService - Updating admin with data:', updateData);
  return patchData('/entity/admin', updateData);
};

// Delete an admin
export const deleteAdmin = async (adminId) => {
  return deleteData('/entity/admin', {
    data: { adminId }
  });
};

// Get admin by ID (if needed for future use)
export const getAdminById = async (adminId) => {
  return getData(`/entity/admin/${adminId}`);
};

export default {
  getAdmins,
  createAdmin,
  updateAdmin,
  deleteAdmin,
  getAdminById
};
